import { render, staticRenderFns } from "./SitemapHub.vue?vue&type=template&id=dffc9fe4&scoped=true&"
import script from "./SitemapHub.vue?vue&type=script&lang=ts&"
export * from "./SitemapHub.vue?vue&type=script&lang=ts&"
import style0 from "./SitemapHub.vue?vue&type=style&index=0&id=dffc9fe4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dffc9fe4",
  null
  
)

export default component.exports